export default class MyAccount {
	constructor() {
		document.addEventListener('DOMContentLoaded', () => {
			this.registerMenuHandlers();
		}, false);

	}

	registerMenuHandlers() {
		if(window.innerWidth < 992) {
			jQuery('.woocommerce-MyAccount-navigation').css('display', 'none')
		}


		jQuery('.back-to-account-navigation a').on('click', function() {
			jQuery('.woocommerce-MyAccount-navigation').slideToggle();
			jQuery('.woocommerce-MyAccount-navigation, .back-to-account-navigation').toggleClass('active')
		});

		jQuery(window).on('resize', function() {
			if(window.innerWidth > 991) {
				jQuery('.woocommerce-MyAccount-navigation').css('display', '')
			}
		});
	}
}
